import { Drawer, Tag } from 'antd';
import type { UserData } from '../CampaignReport.type';
import { Icon } from 'Components';
import { INTERACTION_COLOR, RESULT_COLOR } from '../CampaignReport.constant';

const UserDetailDrawer = ({ data, visible, onClose }: {
  data: UserData | null,
  visible: boolean,
  onClose: () => void
}) => {
  const { color: resultColor, bg: resultBg } = RESULT_COLOR[String(data?.result).toLowerCase()] || RESULT_COLOR.passed;
  const { color: interactionColor, bg: interactionBg } = INTERACTION_COLOR;
  // icon can be systemInteraction | human, check | close
  return (
    <Drawer
      title={
        <div className='header-section'>
          <div className='title-content'>
            <span className='title'>{data?.propertyName || ''}</span>
            <Icon type='close' onClick={onClose} />
          </div>
          <Tag className='status-tag' style={{ color: resultColor, background: resultBg }}>{data?.result || ''}</Tag>
        </div>
      }
      className='user-data-drawer'
      placement="right"
      visible={visible}
      onClose={onClose}
      width={450}
      height="100vh">
      <div className='drawer-body'>
        <div className='data-section'>
          <span className='title'>Details</span>
          <span className='description'>Property: Plaza IT</span>
          <span className='description'>Department: IT </span>
          <span className='description'>Email Address: marcus.rodriguez@plazanyc.com</span>
        </div>

        <div className='data-section'>
          <span className='title'>Automation Analysis</span>
          <span className='description'>Human Interaction <Icon type='systemInteraction' style={{ background: "#E8F1FB" }} /></span> 
          <span className='description'>Confidence: <Tag className='status-tag' style={{ color: resultColor, background: resultBg }} >High</Tag></span>
          <span className='info-banner'>User identity confirmed by trusted IP</span>
        </div>

        <div className='data-section'>
          <span className='title'>Technical details</span>
          <span className='description'>192.168.1.45 New York, NY, USA</span>
          <span className='description'>ISP: Verizon Business</span>
          <span className='description'>User Agent:</span>
          <span className='info-banner'>Mozilla/5.0 (WIndows NT 10.0, Win64, x64) AppleWebKit/537.36</span>
        </div>

        <div className='data-section'>
          <span className='title'>Delivery & Interaction</span>
          <span className='description'>Email delivered: Yes <Icon type='check' style={{ color: resultColor, background: resultBg }} /></span>
          <span className='description'>Interaction: <Tag className='status-tag' style={{ color: interactionColor, background: interactionBg }}  >Submitted data</Tag></span>
          <span className='description'>Submission: 12/15/2024 2:34PM</span>
        </div>
      </div>
    </Drawer>
  );
};

export default UserDetailDrawer;